import React from 'react';
import { graphql } from 'gatsby';
import LayoutWrapper from '../components/layout';
import Markdown from 'react-markdown';

function Document({ data }) {
  const { markdownRemark } = data;
  const { frontmatter, rawMarkdownBody } = markdownRemark;
  return (
    <LayoutWrapper>
      <div className='lg:px-48 px-6'>
        <h1 className='text-teal-600 text-3xl lg:text-5xl font-bold lg:pt-36 pt-10 lg:pb-10 pb-4'>
          {frontmatter.title}
        </h1>
        <Markdown>{rawMarkdownBody}</Markdown>
      </div>
      <div className='w-full h-10 bg-secondary-light my-8' />
    </LayoutWrapper>
  );
}

export default Document;

export const pageQuery = graphql`
  query ($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        slug
        title
      }
      rawMarkdownBody
    }
  }
`;
